import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { AuthState } from './auth';
import { HexabaseState } from './hexabase';
import { UserState } from './user';
import { ConstructionState } from './construction';

Vue.use(Vuex);

export interface RootState {
  auth: AuthState;
  user: UserState;
  hexabase: HexabaseState;
  construction: ConstructionState;
}

export default new Vuex.Store<RootState>({
  plugins: [
    createPersistedState({
      key: 'zion-ui',
      paths: ['auth', 'user', 'hexabase'],
      storage: window.sessionStorage
    })
  ]
});
